export const leadStatusTypeConstants = [
  { name: "General", value: 1 },
  { name: "Success", value: 2 },
  { name: "Dead", value: 3 },
];
